// Korean — partial translation seeded over the English catalogue.
// Every key not overridden here falls back to en.js (fallbackLocale)
// and the spread below keeps the full structure intact for tooling.
// Extend section by section; keep keys identical to en.js.
import en from "./en";

export default {
    ...en,
    Projects: {
        ...en.Projects,
        tasks: "작업",
        save: "저장",
        cancel: "취소",
        delete: "삭제",
        status: "상태",
        priority: "우선순위",
        due_date: "마감일",
        assignee: "담당자",
        new_task: "새 작업",
        add_subtask: "하위 작업 추가",
        archive: "보관",
        duplicate: "복제",
        group_by: "그룹화",
        subtask: "하위 작업",
        expanded: "펼침",
        collapsed: "접힘",
        me: "나",
        burndown: "번다운",
        select_sprint: "스프린트",
        no_burndown_data: "이 스프린트의 데이터가 아직 없습니다",
        recent_tasks: "최근",
        no_recent_tasks: "최근에 본 작업이 없습니다",
        global_search: "전체 검색",
        search_everything: "작업, 프로젝트, 댓글 검색...",
        no_search_results: "검색 결과가 없습니다",
        epics: "에픽",
        add_epic: "추가",
        epic_name_placeholder: "새 에픽 이름...",
        no_epics: "에픽이 아직 없습니다",
        select_epic: "에픽에 추가",
        remove_from_epic: "에픽에서 제거",
        export_tasks: "내보내기",
        export_preparing: "내보내기를 준비 중입니다...",
        export_ready: "내보내기 완료 — 다운로드 중",
        export_failed: "내보내기에 실패했습니다",
        pages: "페이지",
        add_page: "새로 만들기",
        no_pages: "페이지가 아직 없습니다",
        select_page: "페이지를 선택하거나 만드세요",
        save_page: "저장",
        untitled_page: "제목 없는 페이지",
        page_versions: "기록",
        page_restored: "버전이 복원되었습니다",
        edit: "편집",
        preview: "미리보기",
        insert_task_chip: "작업 칩 삽입",
        search_task: "작업 이름 또는 키로 검색...",
        no_tasks_found: "작업을 찾을 수 없습니다",
        unknown_status: "알 수 없음",
        public_link: "공개 링크",
        create_public_link: "공개 링크 만들기",
        move_to_folder: "폴더로 이동",
        no_folder_root: "폴더 없음 (루트)",
        select_folder: "이 스프린트를 이동할 폴더를 선택하세요",
        link_enabled: "링크 활성화",
        allow_intake: "외부 요청 받기",
        intake_inbox: "요청",
        no_intake: "대기 중인 요청이 없습니다",
        anonymous: "익명",
        accept: "승인",
        reject: "거절",
        import_jira: "Jira 가져오기",
        import_asana: "Asana 가져오기",
        import_monday: "Monday.com 가져오기",
        importing: "가져오는 중...",
        start_import: "가져오기",
        linked_tasks: "연결된 작업",
        add_link: "작업 연결",
        remove_link: "연결 해제",
        no_linked_tasks: "연결된 작업이 아직 없습니다",
        searching: "검색 중...",
        add_reaction: "리액션 추가",
    },
    Comments: {
        ...en.Comments,
        edit: "수정",
        reply: "답글",
        copy_message: "메시지 복사",
        more: "더 보기",
        less: "접기",
        edited: "수정됨",
    },
    AI: {
        ...en.AI,
        ai_write_description: "AI로 작성",
        ai_desc_intent_placeholder: "이 설명에 무엇을 담을까요? (선택)",
        ai_desc_intent_hint: "비워 두면 제목에서 생성합니다.",
        ai_generate: "생성",
        ai_regenerate: "다시 생성",
        ai_use_this: "사용하기",
        ai_answer_questions: "정확한 설명을 위해 간단한 질문 몇 가지에 답해 주세요:",
        ai_generating: "생성 중…",
        ai_failed: "설명을 생성하지 못했습니다. 다시 시도해 주세요.",
    },
};
